export const GET_BADGES    = "GET_BADGES";
export const ADD_BADGE     = "ADD_BADGE";
export const UPDATE_BADGE  = "UPDATE_BADGE";
export const DELETE_BADGE  = "DELETE_BADGE";
